<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'ProcessRiskPoint'}">风险点</el-breadcrumb-item>
        <el-breadcrumb-item>风险点详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div style="width: 80%;margin: auto;padding-bottom:10px">
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: 666666; font-size: 16px">基础信息</span>
          </el-divider>
        </div>
        <div class="detailBox">
          <div class="divBox">编号：<span>{{ obj.number }}</span></div>
          <div class="divBox">所属区域：<span>{{ obj.areaName }}</span></div>
          <div class="divBox">所属部门：<span>{{ obj.depName }}</span></div>
          <div>风险类型：
            <el-tag size="small">{{ riskTypeArr[obj.riskType].name }}</el-tag>
          </div>
          <!-- <div>分析方法：<span>{{ obj.auditEmpName }}</span></div> -->
          <div v-if="obj.analyticalMethod">评估结果：
            <span v-for="item in obj.analyticalMethod.split(',')" :key="item" style="margin-right: 15px">{{ analyticalMethodArr[item - 1] }}
              <!-- ls -->
              <span v-if="item === '1' || item === '4'">
                <el-tag v-if="obj.riskMatrix === null || obj.riskMatrix === undefined" size="small" type="info">未评估</el-tag>
                <el-tag v-if="obj.riskMatrix === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
                <el-tag v-if="obj.riskMatrix === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
                <el-tag v-if="obj.riskMatrix === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
                <el-tag v-if="obj.riskMatrix === 3" size="small" effect="dark">低风险</el-tag>
              </span>
              <!-- lec -->
              <span v-if="item === '2' || item === '5'">
                <el-tag v-if="obj.riskAnalysis === null || obj.riskAnalysis === undefined" size="small" type="info">未评估</el-tag>
                <el-tag v-if="obj.riskAnalysis === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
                <el-tag v-if="obj.riskAnalysis === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
                <el-tag v-if="obj.riskAnalysis === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
                <el-tag v-if="obj.riskAnalysis === 3" size="small" effect="dark">低风险</el-tag>
              </span>
              <!-- mes -->
              <span v-if="item === '3' || item === '6'">
                <el-tag v-if="obj.degreeAnalysis === null || obj.degreeAnalysis === undefined" size="small" type="info">未评估</el-tag>
                <el-tag v-if="obj.degreeAnalysis === 0" type="danger" size="small" effect="dark">重大风险</el-tag>
                <el-tag v-if="obj.degreeAnalysis === 1" type="warning" size="small" effect="dark">较大风险</el-tag>
                <el-tag v-if="obj.degreeAnalysis === 2" style="color: #666666;background: yellow;borderColor: yellow" size="small" effect="dark">一般风险</el-tag>
                <el-tag v-if="obj.degreeAnalysis === 3" size="small" effect="dark">低风险</el-tag>
              </span>
            </span>
          </div>
          <div>风险等级：
            <el-tag v-if="obj.color === '重大风险'" effect="dark" type="danger" style="color: #ffffff;background: #ff0000;borderColor: #ff0000" size="small">重大风险</el-tag>
            <el-tag v-if="obj.color === '较大风险'" effect="dark" type="warning" style="color: #ffffff;background: #ff6200;borderColor: #ff6200" size="small">较大风险</el-tag>
            <el-tag v-if="obj.color === '一般风险'" effect="dark" style="color: #666666;background: yellow;borderColor: yellow" size="small">一般风险</el-tag>
            <el-tag v-if="obj.color === '低风险'" effect="dark" style="color: #666666;background: #00d0ff;borderColor: #00d0ff" size="small">低风险</el-tag>
          </div>
          <div class="divBox">辨识人员：<span>{{ obj.identifyEmpName }}</span></div>
          <div class="divBox">风险控制人员：<span>{{ obj.controllerEmpName }}</span></div>
          <div class="divBox">评估人员：<span>{{ obj.evaluatorEmpName }}</span></div>
          <!-- <div class="divBox">通知人：<span>{{ obj.auditTime }}</span></div> -->
          <div class="divBox">评估日期：<span>{{ obj.evaluationTime }}</span></div>
          <div class="divBox">复评日期：<span>{{ obj.nextEvaluationTime }}</span></div>
          <div>管控层级：
            <el-tag v-if="obj.controlHierarchy === 0" effect="dark" type="danger" size="small">公司级</el-tag>
            <el-tag v-if="obj.controlHierarchy === 1" effect="dark" type="warning" size="small">车间级</el-tag>
            <el-tag v-if="obj.controlHierarchy === 2" effect="dark" size="small">部门级</el-tag>
            <el-tag v-if="obj.controlHierarchy === 3" effect="dark" size="small">班组级</el-tag>
            <el-tag v-if="obj.controlHierarchy === 4" effect="dark" size="small">岗位级</el-tag>
          </div>
        </div>
        <div style="margin: 50px 0" v-if="riskTypeArr[obj.riskType].name !== '固有风险'">
          <el-divider content-position="left">
            <span style="color: #666666; font-size: 16px">风险辨识记录</span>
          </el-divider>
          <el-table :data="identifyList" style="width: 100%" border :header-cell-style="{ background: 'rgb(245,247,250)' }">
            <el-table-column type="index" label="序号" width="100" />
            <el-table-column prop="identifyName" label="辨识名称">
              <template slot-scope="{ row }">
                <el-link style="color: #2d8cf0" @click="jumpBS(row.identifyName)">{{ row.identifyName }}</el-link>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="sign" label="警示标识" /> -->
            <el-table-column prop="responsibleEmpName" label="责任人" />
            <el-table-column prop="responsiblePhone" label="责任人电话" />
            <el-table-column prop="auditEmpName" label="审核人" />
          </el-table>
        </div>
        <div style="margin: 50px 0" v-if="riskTypeArr[obj.riskType].name !== '固有风险'">
          <el-divider content-position="left">
            <span style="color: #666666; font-size: 16px">风险管控记录</span>
          </el-divider>
          <el-table :data="controllerList" style="width: 100%" border :header-cell-style="{ background: 'rgb(245,247,250)' }">
            <el-table-column type="index" label="序号" width="100" />
            <!-- <el-table-column prop="riskControlMeasureName" label="风险源/潜在事件" /> -->
            <el-table-column prop="controllerName" label="管控名称">
              <template slot-scope="{ row }">
                <el-link style="color: #2d8cf0" @click="jumpGK(row.controllerName)">{{ row.controllerName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="responsibleEmpName" label="责任人" />
            <el-table-column prop="responsiblePhone" label="责任人电话" />
            <el-table-column prop="auditEmpName" label="审核人" />
          </el-table>
        </div>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: #666666; font-size: 16px">报警记录</span>
          </el-divider>
          <el-table :data="tableDataBJ" style="width: 100%" border :header-cell-style="{ background: 'rgb(245,247,250)' }">
            <el-table-column type="index" label="序号" width="100" />
            <el-table-column prop="collectionTime" label="报警时间" />
            <el-table-column prop="tagName" label="采集点名" />
            <el-table-column prop="value" label="报警值" />
            <el-table-column prop="alertType" label="报警类型">
              <template slot-scope="{ row }">
                <span v-if="row.alertType">{{ alertTypeList[row.alertType] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="处理状态">
              <template slot-scope="{ row }">
                <span>{{ statusList[row.status] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: #666666; font-size: 16px">排查记录</span>
          </el-divider>
          <el-table :data="tableDataPC" style="width: 100%" border :header-cell-style="{ background: 'rgb(245,247,250)' }">
            <el-table-column prop="planName" label="排查名称" />
            <el-table-column prop="planStartTime" label="开始时间" />
            <el-table-column prop="planEndTime" label="结束时间" />
            <el-table-column label="状态">
              <template slot-scope="{ row }">
                <el-tag v-if="row.status === 0" type="success" size="small">未排查</el-tag>
                <el-tag v-else type="warning" size="small">已排查</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="totalPC > 10" style="margin-top: 10px;text-align: right">
            <Page :total="totalPC" :current="curPagePC" :page-size="pageSizePC" @on-change="pageChangePC" />
          </div>
        </div>
        <div style="margin: 50px 0">
          <el-divider content-position="left">
            <span style="color: #666666; font-size: 16px">巡检记录</span>
          </el-divider>
          <el-table :data="tableDataXJ" style="width: 100%" border :header-cell-style="{ background: 'rgb(245,247,250)' }">
            <el-table-column prop="number" width="180" label="编号">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="250"></el-table-column>
            <el-table-column prop="error_status" label="异常状态" width="150">
              <template slot-scope="scope">
                <el-tag type="success" size="mini" v-if="scope.row.error_status == 0">正常</el-tag>
                <el-tag type="warning" size="mini" v-if="scope.row.error_status == 1">异常</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="userVos" label="巡检人">
              <template slot-scope="scope">
                <el-tag
                  v-for="(item1) in scope.row.checkingPeoples"
                  type="info"
                  :key="item1.id"
                >{{item1.name}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="info">待巡检</el-tag>
                <el-tag v-if="scope.row.status == 1" type="info">已巡检</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="totalXJ > 10" style="margin-top: 10px;text-align: right">
            <Page :total="totalXJ" :current="curPageXJ" :page-size="pageSizeXJ" @on-change="pageChangeXJ" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { riskPointDetailListData, riskPointDetail, getPointAlartRecord,
 riskPointPClist, riskPointXJlist } from '@/api/processManager'
export default {
  name: 'riskPointDetail',
  data() {
    return {
      obj: {
        riskType: 2
      },
      riskTypeArr: [
        { name: '固有风险', id: 0 },
        { name: '作业风险', id: 1 },
        { name: '设备风险', id: 2 }
      ],
      // 分析方法
      analyticalMethodArr: ['JHA_LS', 'JHA_LEC', 'JHA_MES', 'SCL_LS', 'SCL_LEC', 'SCL_MES'],
      controllerList: [],
      identifyList: [],
      tableDataBJ: [],
      alertTypeList: ['', '高高报', '高报', '低报', '低低报', '设备故障'],
      statusList: ['待核实', '待处置', '待复查', '完成'],
      // 排查记录
      tableDataPC: [],
      totalPC: 0,
      curPagePC: 1,
      pageSizePC: 10,
      // 巡检记录
      tableDataXJ: [],
      totalXJ: 0,
      curPageXJ: 1,
      pageSizeXJ: 10
    }
  },
  async created() {
    await this.getDetail();
    this.getTableData();
    this.getAlarmRecord();
    this.getPC();
    this.getXJ()
  },
  methods: {
    // 获取风险点详情
    async getDetail() {
      await riskPointDetail(this.$route.query.id).then(res => {
        this.obj = res.body.data
      })
    },
    getTableData() {
      riskPointDetailListData(this.$route.query.id).then(res => {
        this.controllerList = res.body.data.controllerList
        this.identifyList = res.body.data.identifyList
      })
    },
    // 获取报警记录
    getAlarmRecord() {
      getPointAlartRecord({ dangerInfoId: this.obj.dangerAreaId }).then(res => {
        this.tableDataBJ = res.body.data;
        this.totalXJ = res.body.cum
      })
    },
    // 跳转到两单辨识列表
    jumpBS(identifyName) {
      this.$router.push({
        path: 'twoOrderNew',
        query: { searchContent: identifyName }
      })
    },
    // 跳转到两单管控列表
    jumpGK(controllerName) {
      this.$router.push({
        path: 'twoOrderNew',
        query: { status: 'second' ,searchContent: controllerName }
      })
    },
    // 获取排查列表
    getPC() {
      riskPointPClist({ id: this.$route.query.id, curPage: this.curPagePC, limit: this.pageSizePC }).then(res => {
        this.tableDataPC = res.body.data
        this.totalPC = res.body.cum
      })
    },
    // 排查翻页
    pageChangePC(val) {
      this.curPagePC = val
      this.getPC()
    },
    // 巡检列表
    getXJ() {
      riskPointXJlist({ id: this.$route.query.id, curPage: this.curPageXJ, limit: this.pageSizeXJ }).then(res => {
        this.tableDataXJ = res.body.data
        this.totalXJ = res.body.cum
      })
    },
    // 巡检翻页
    pageChangeXJ(val) {
      this.curPageXJ = val
      this.getXJ()
    },
  }
}
</script>

<style scoped>
.detailBox {
  display: flex;
  flex-wrap: wrap;
}
.detailBox > div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox >  .divBox > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px;
}
</style>
